import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'vui-ternary-form-fields',
    templateUrl: './ternary-form-fields.component.html',
    styleUrls: ['./ternary-form-fields.component.scss']
})
export class TernaryFormFieldsComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
